import { useMemo } from "react";

import { Dialog, DialogTitle, DialogContent, Stack } from "@mui/material";
import { Select } from "components";
import { useAppDispatch, useAppSelector } from "stores";
import { authSlice } from "stores/Auth";
import { i18n } from "translations";
import { rem } from "utils";

const OrganizationDialog = (props: { onToggle: () => void }) => {
  const { onToggle } = props;
  const dispatch = useAppDispatch();
  const userProfile = useAppSelector((state) => state.auth.userProfile);
  const orgSelected = useAppSelector((state) => state.auth.orgSelected);

  const orgList = useMemo(() => {
    return userProfile?.organizations.reduce(
      (unique: { value: string; label: string }[], org) => {
        if (!unique.some((o) => Number(o.value) === Number(org.id))) {
          unique.push({
            value: String(org.id),
            label: String(org.name),
          });
        }
        return unique;
      },
      []
    );
  }, [userProfile?.organizations]);

  const handleMenuItemClick = (value: string) => {
    const currentOrgSelected = userProfile?.organizations?.find(
      (orgItem) => orgItem.id === Number(value)
    );
    if (String(value) !== String(orgSelected?.id)) {
      dispatch(authSlice.actions.setOrgSelected({ org: currentOrgSelected }));
    }
  };

  return (
    <Dialog
      PaperProps={{
        sx: {
          overflow: "unset",
        },
      }}
      open
      onClose={onToggle}
      fullWidth
    >
      <DialogTitle>{i18n.t("changeOrganization")}</DialogTitle>
      <DialogContent>
        <Stack rowGap={rem(16)} pt={2}>
          <Select
            label={i18n.t("organization")}
            options={orgList as never}
            value={String(orgSelected.id)}
            onChange={handleMenuItemClick}
            clearable={false}
          />
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default OrganizationDialog;
